<app-mixit-x509-banner/>
@if (alarm$ | async) {
  <app-alarm-bar [alarm]="alarm$"> </app-alarm-bar>
}

<app-schematics-tile
  [installationId]="(installation$ | async)?.id"
  [applicationId]="application.id"
  [showShadow]="false"
  [dataPoints$]="dataPoints$"
  >
</app-schematics-tile>

@if (installation$ | async; as installation) {
  @if (hasWeatherCurve$ | async) {
    <app-building-connect-weather-curve-tile
      [installation]="installation"
      [application]="application"
      [outdoorTemp$]="outdoorTemp$"
      >
    </app-building-connect-weather-curve-tile>
  }
}

@if (isWarmWeatherShutdownAvailable$ | async) {
  <app-warm-weather-shutdown-tile
    [installationId]="(installation$ | async)?.id"
    [applicationId]="application.id"
    [dataPoints$]="dataPoints$"
  ></app-warm-weather-shutdown-tile>
}

<app-heat-meter-status-tile
  [installation$]="installation$"
  [application]="application"
  [dataPoints$]="dataPoints$"
  [schematic$]="schematic$"
  >
</app-heat-meter-status-tile>

<app-forward-return-chart-tile
  [title]="'district-heating-dashboard.temperature-title' | translate"
  [applicationId]="application.id"
  forwardDumbledoreId="T_PF"
  returnDumbledoreId="T_PR"
  [dataPoints$]="dataPoints$"
  [userTrackingPeriodOptions]="{ category: 'application/unspecifiedLoad', intervalPrefix: 'temperature' }"
  >
</app-forward-return-chart-tile>

<app-forward-return-chart-tile
  [title]="'district-heating-dashboard.temperature-title' | translate"
  [applicationId]="application.id"
  forwardDumbledoreId="T_F"
  returnDumbledoreId="T_R"
  [dataPoints$]="dataPoints$"
  [userTrackingPeriodOptions]="{ category: 'application/unspecifiedLoad', intervalPrefix: 'temperature' }"
  >
</app-forward-return-chart-tile>
